module.exports = {
  title: 'Chrome Midnight',
  description: `
    I got tired of the selection of themes for Google Chrome in the Chrome Store, so I decided to take a stab at making one myself.
    I wanted something simple, dark, and resembled Play Midnight. This came to be Chrome Midnight.
  `,
  tags: ['Chrome Theme API', 'Design',],
  images: [require('./images/1.png'),],
  url: 'https://chrome.google.com/webstore/detail/chrome-midnight-for-googl/nkdgbjikipjllfbloomnlfmghnfmimmd?hl=en',
};



// WEBPACK FOOTER //
// ./src/data/works/chromemidnight/index.js